import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    makeStyles,
} from '@material-ui/core';

interface ModalProps {
    open: boolean;
    title: string;
    onClose: () => void;
    icon?: React.ReactNode;
    children: React.ReactNode;
    maxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | false;
}

const Modal = ({
    open,
    title,
    onClose,
    icon,
    children,
    maxWidth = 'xl',
}: ModalProps) => {
    const classes = useStyles();

    return (
        <Dialog
            open={open}
            fullWidth
            className={classes.root}
            onClose={onClose}
            maxWidth={maxWidth}
        >
            <div className={classes.modal}>
                <div className={classes.gradient} />
                <DialogTitle className={classes.header}>
                    {icon && <div className={classes.icon}>{icon}</div>}
                    <div className={classes.title}>{title}</div>
                </DialogTitle>
                <DialogContent className={classes.content}>
                    {children}
                </DialogContent>
                <DialogActions className={classes.actions}>
                    <Button
                        onClick={onClose}
                        className={`${classes.button} ${classes.cancelButton}`}
                    >
                        Close
                    </Button>
                </DialogActions>
            </div>
        </Dialog>
    );
};

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        position: 'relative',
    },
    modal: {
        display: 'flex',
        padding: '40px 12px 60px 12px',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'flex-start',
        position: 'relative',
        minWidth: '500px',
    },
    gradient: {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '20px',
        height: '100%',
        background: 'linear-gradient(0deg, #D6E6FF 0%, #E4FEFF 100%)',
    },
    header: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: '40px',
        marginLeft: '40px',
    },
    icon: {
        display: 'flex',
        alignItems: 'center',
        marginRight: '27px',
        float: 'left',
        width: '49px',
        height: '49px',
    },
    title: {
        display: 'flex',
        color: theme.palette.primary.main,
        fontFamily: 'Poppins',
        fontSize: '32px',
        fontStyle: 'normal',
        fontWeight: 500,
        lineHeight: '150%',
        letterSpacing: '-0.576px',
    },
    content: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: '60px',
        alignSelf: 'stretch',
        marginLeft: '40px',
        marginRight: '20px',
    },
    actions: {
        paddingRight: '20px',
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        gap: '20px',
        alignSelf: 'stretch',
        marginBottom: '-30px',
        marginTop: '30px',
        marginLeft: '40px',
        marginRight: '20px',
    },
    button: {
        display: 'flex',
        height: '36px',
        padding: '4px 24px',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '10px',
        borderRadius: '25px',
        color: theme.palette.primary.main,
        fontFamily: 'Noto Sans',
        fontSize: '14px',
        fontStyle: 'normal',
        fontWeight: 600,
        lineHeight: '150%',
        letterSpacing: '-0.14px',
        textTransform: 'none',
    },
    cancelButton: {
        backgroundColor: theme.palette.gray.light,
    },
}));

export default Modal;
